<template>
  <div class="container flex flex-col text-center">
    <section class="flex flex-col section items-center">
      <SvgVue
        icon="icomoon/party"
        class="icon Icon Icon--party mb-7 inline-block"
      />
      <h1 class="mb-7">
        Geschafft!
      </h1>
      <p class="mb-7 max-w-lg">
        Vielen Dank, dass {{ duzen('du dir die Zeit genommen hast', 'Sie sich die Zeit genommen haben') }}.
        Eine individuelle Auswertung {{ duzen('erhältst du in deinem', 'erhalten Sie in Ihrem') }}
        persönlichen Gespräch.
      </p>
      <div
        v-if="!isMobile"
        class="flex flex-row items-center justify-center gap-4"
      >
        <AppButton
          :handler="userStore.logUserOutByUser"
          type="primary"
          text
          bg
        >
          <template #icon>
            <FaIcon name="sign-out-alt" />
          </template>
          Ausloggen
        </AppButton>
        <RouterLink
          v-slot="{ navigate }"
          :to="{ name: Finanzmanager.VERTRAEGE }"
          custom
        >
          <AppButton
            v-if="!useAppUser().isShallow()"
            type="primary"
            :handler="navigate"
          >
            <template #icon>
              <FaIcon name="handshake" variant="regular" />
            </template>
            Meine Verträge
          </AppButton>
        </RouterLink>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';

import SvgVue from '@/application/components/SvgVue';
import { Finanzmanager } from '@/application/router/types/types';
import { resetState } from "@/checkup/state";
import { onMounted } from "vue";
import { useUserStore } from "@/user/store/userStore";
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import { useAppUser } from "@/application/composables/useAppUser.ts";
import { useDetectMobile } from "@/application/composables/detectMobile.ts";

onMounted(() => {
  resetState();
})

const userStore = useUserStore();
const { duzen } = useBaseDataStore();
const { isMobile } = useDetectMobile();
</script>
